import './Text.css';

function Text({ children, as: Tag = 'p', size = 'normal', className = '' }) {
  const classNames = `text text--${size} ${className}`.trim();
  return <Tag className={classNames}>{children}</Tag>;
}

export default Text;
